export default {
    'draw deck-bottom': {
        bottom: '140px'
    },
    'discard pile-bottom': {
        bottom: '155px'
    },
    'discard pile-top': {
        top: '185px'
    },
    'dead pile-bottom': {
        bottom: '140px'
    },
    'dead pile-top': {
        top: '165px'
    },
    'out of game-top': {
        top: '155px',
        left: '20px'
    },
    'out of game-bottom': {
        bottom: '155px',
        right: '0'
    },
    'being played-bottom': {
        bottom: '140px'
    },
    'draw hand-bottom': {
        bottom: '155px'
    },
    'draw hand-top': {
        top: '185px'
    }
};
